import React from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { DiagnosticoSection } from './components/DiagnosticoSection';
import { SistemaAceSection } from './components/SistemaAceSection';
import { ContactFormSection } from './components/ContactFormSection';
import { CtaFinalSection } from './components/CtaFinalSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-carbon font-body text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProofSection data-id="element-2" />
      <DiagnosticoSection data-id="element-3" />
      <SistemaAceSection data-id="element-4" />
      <ContactFormSection data-id="element-5" />
      <CtaFinalSection data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}